import styled from 'styled-components';

/* Not the shared Table: that one is built for paginated API rows with a
   header, sorting and an empty state. This is four static lines. */
export const TimingRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 0;

  & + & {
    border-top: ${({ theme }) => theme.borders.border1};
  }

  /* The timing under the provider rather than beside it, once the two stop
     fitting on one line. */
  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
`;

export const TimingValue = styled.div`
  flex: none;
  text-align: right;

  @media (max-width: 600px) {
    text-align: left;
  }
`;
